import { TestContext, ValidationError } from 'yup';

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Валидирует список email-адресов, разделенных запятой, точкой с запятой или переносом строки.
 */
export const validateEmailList = (
    value: string | undefined, 
    context: TestContext
): boolean | ValidationError => {
    if (!value || !value.trim()) {
        return context.createError({ message: 'Mailing list is required' });
    }

    // Разбиваем строку по запятой, точке с запятой или переносу строки
    const emails = value
        .split(/[,;\n]+/)
        .map(email => email.trim())
        .filter(Boolean);

    if (emails.length === 0) {
        return context.createError({ message: 'Mailing list cannot be empty' });
    }

    // Находим все невалидные адреса
    const invalidEmails = emails.filter(email => !EMAIL_REGEX.test(email));

    if (invalidEmails.length > 0) {
        return context.createError({
            message: `Invalid email(s): ${invalidEmails.join(', ')}`
        });
    }

    return true;
};